/* eslint-disable */
import { StreamWriter } from '@syncfusion/ej2-file-utils';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
/**
 * Exports the document to Text format.
 */
export class TextExport {
    constructor() {
        /**
         * @private
         */
        this.pageContent = '';
        this.curSectionIndex = 0;
        this.inField = false;
    }
    getModuleName() {
        return 'TextExport';
    }
    /**
     * @private
     * @param {DocumentHelper} documentHelper - Document helper.
     * @param {string} fileName - Specified file name.
     * @return {void}
     */
    save(documentHelper, fileName) {
        this.serialize(documentHelper);
        const writer = new StreamWriter();
        this.writeInternal(writer);
        writer.save(fileName + '.txt');
    }
    /**
     * Save text document as Blob.
     *
     * @private
     * @param {DocumentHelper} documentHelper - Document helper.
     * @return {Promise<Blob>} - Returns promise object.
     */
    saveAsBlob(documentHelper) {
        this.serialize(documentHelper);
        const streamWriter = new StreamWriter();
        this.writeInternal(streamWriter);
        const blob = streamWriter.buffer;
        streamWriter.destroy();
        return new Promise((resolve, reject) => {
            resolve(blob);
        });
    }
    serialize(documentHelper) {
        const document = documentHelper.owner.sfdtExportModule.write(0);
        this.setDocument(document);
    }
    /**
     * @private
     * @param document
     */
    setDocument(document) {
        this.document = document;
        this.mSections = document.sections;
    }
    /**
     * @private
     * @param streamWriter - Stream writer instance.
     * @return {void}
     */
    writeInternal(streamWriter) {
        let section = undefined;
        const sectionCount = this.document.sections.length - 1;
        let isLastSection = false;
        this.updateLastParagraph();
        for (let i = 0; i <= sectionCount; i++) {
            section = this.document.sections[i];
            isLastSection = (i === sectionCount) ? true : false;
            this.writeBody(streamWriter, section.blocks, false);
            this.writeNewLine(streamWriter);
            this.writeSectionEnd(section, isLastSection);
        }
        for (let j = 0; j <= sectionCount; j++) {
            section = this.document.sections[j];
            this.writeHeadersFooters(streamWriter, section);
        }
    }
    /// <summary>
    /// Writes the specified document content to the text file.
    /// </summary>
    writeBody(streamWriter, body, isHeaderFooter) {
        const bodyItemsCount = body.length - 1;
        let bodyItem = undefined;
        for (let i = 0; i <= bodyItemsCount; i++) {
            bodyItem = body[i];
            if (bodyItem.hasOwnProperty('inlines')) {
                const isLastPara = (bodyItem === this.lastPara) ? true : false;
                this.writeParagraph(streamWriter, bodyItem, isLastPara, isHeaderFooter);
            }
            else if (bodyItem.blocks) {
                this.writeBody(streamWriter, bodyItem.blocks, isHeaderFooter);
            }
            else {
                this.writeTable(streamWriter, bodyItem);
            }
        }
    }
    writeParagraph(streamWriter, paragraph, isLastPara, isHeaderFooter) {
        for (let i = 0; i < paragraph.inlines.length; i++) {
            const item = paragraph.inlines[i];
            if (item.hasOwnProperty('fieldType')) {
                this.inField = item.fieldType === 0;
            }
            else if (item.hasOwnProperty('text') && !this.inField) {
                this.writeText(streamWriter, item.text);
            }
        }
        if (!isHeaderFooter || paragraph.inlines.length > 0)
            if (!isLastPara) {
                this.writeNewLine(streamWriter);
            }
    }
    /// }
    /// <summary>
    /// Writes the specified table text content to the text file.
    /// </summary>
    writeTable(streamWriter, table) {
        for (let i = 0; i < table.rows.length; i++) {
            const row = table.rows[i];
            for (let j = 0; j < row.cells.length; j++) {
                const cell = row.cells[j];
                this.writeBody(streamWriter, cell.blocks, false);
            }
        }
    }
    /// <summary>
    /// Writes the specified Header Footer text content to the text file.
    /// </summary>
    writeHeadersFooters(streamWriter, section) {
        const headersFooters = section.headersFooters;
        if (isNullOrUndefined(headersFooters)) {
            return;
        }
        this.writeHeaderFooter(streamWriter, section.headersFooters.header);
        this.writeHeaderFooter(streamWriter, section.headersFooters.footer);
        this.writeHeaderFooter(streamWriter, section.headersFooters.evenFooter);
        this.writeHeaderFooter(streamWriter, section.headersFooters.evenHeader);
        this.writeHeaderFooter(streamWriter, section.headersFooters.firstPageHeader);
        this.writeHeaderFooter(streamWriter, section.headersFooters.firstPageFooter);
    }
    writeHeaderFooter(streamWriter, headerFooter) {
        if (headerFooter && headerFooter.blocks) {
            this.writeBody(streamWriter, headerFooter.blocks, true);
        }
    }
    /// <summary>
    /// Writes the end of the section.
    /// </summary>
    writeSectionEnd(section, lastSection) {
        this.curSectionIndex++;
    }
    writeNewLine(writer) {
        if (!isNullOrUndefined(writer)) {
            writer.writeLine('');
        }
        else {
            this.pageContent = this.pageContent + ' ';
        }
    }
    writeText(writer, text) {
        if (!isNullOrUndefined(writer)) {
            writer.write(text);
        }
        else {
            this.pageContent += text;
        }
    }
    updateLastParagraph() {
        const cnt = this.document.sections.length;
        let sec;
        if (cnt > 0) {
            sec = this.document.sections[cnt - 1];
        }
        if (!isNullOrUndefined(sec)) {
            const paragraphs = [];
            for (let i = 0; i < sec.blocks.length; i++) {
                if (sec.blocks[i].hasOwnProperty('inlines')) {
                    paragraphs.push(sec.blocks[i]);
                }
            }
            const pCount = paragraphs.length;
            if (pCount > 0) {
                this.lastPara = paragraphs[pCount - 1];
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.document = undefined;
        this.lastPara = undefined;
        this.mSections = undefined;
        this.sections = [];
        this.sections = undefined;
        this.pageContent = undefined;
    }
}
